import React, { useState, useEffect } from 'react';

import "./StoreHomePage.css";
import OfferBannersCard from "./OfferBannersCard";
import CategoriesScrollCard from "./CategoriesScrollCard";
import FlashSaleCard from "./FlashSaleCard";

import IconsGridCard from "./IconsGridCard";
import MainMenu from "./MainMenu";
import { fetchStoreHomeComponents } from "../apiservices/ApiService";
import { FaShoppingBag, FaSpinner } from 'react-icons/fa';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import Card17Product from '../cards/Card17Product';
import LoadingScreenBlackLogo from '../common/LoadingProgressBar';
import { ShoppingBag, ShoppingCartIcon } from 'lucide-react';
import { ShoppingCart } from '@mui/icons-material';


const StoreHomePage = () => {
    const [cards, setCards] = useState([]);
    const [currentPage, setCurrentPage] = useState(1); // Tracks the current page
    const [isLoading, setIsLoading] = useState(false); // Tracks loading state
    const [hasMore, setHasMore] = useState(true); // Tracks if more data is available

  
    const fetchCards = async () => {
        try {
            if (!isLoading && hasMore) {
                setIsLoading(true);
                // Pass pagination dynamically
                const response = await fetchStoreHomeComponents({ pageId: currentPage });

                if (response.cards != null) {
                    if (currentPage == 1)
                        setCards(response.cards)
                    else
                        setCards((prevCards) => [...prevCards, ...response.cards]); // Append new cards
                    setHasMore(response.cards.length > 0); // Check if more cards are available
                    setIsLoading(false);
                } else {
                    setHasMore(false); // No more cards
                }
            }
        } catch (err) {
            setIsLoading(false);
            console.log(err.message || "Failed to fetch profile");
        }
    };

    // Initial fetch
    useEffect(() => {
       
        console.log("useEffect");
        fetchCards();
    }, []);

    // Load More Cards
    const loadMoreCards = () => {
        if (!isLoading && hasMore) {
            setCurrentPage(currentPage + 1);
            console.log("loadMoreCards");
            console.log(currentPage);
            fetchCards();
        }
    };

    const [cartCount, setCartCount] = useState("");

    const handleCartCount = (value) => {
        // Update the state in the parent component with the value from ProductsCarousel
        setCartCount(value);
    };

    // Handle Scroll for Infinite Scrolling
    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop >=
                document.documentElement.offsetHeight - 100 // Trigger near the bottom
            ) {
                loadMoreCards();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [currentPage, isLoading, hasMore]);

    // Navigate to Cart Page
    const cartPageNavigation = () => {
        const currentQueryParams = window.location.search;
        window.location.href = `/store_cart_page${currentQueryParams}`;
    };

    const handleBackButtonPress = () => {
        if (window.Android && window.Android.onBackPressed) {
            window.Android.onBackPressed();
        } else {
            console.log("Back button pressed: No Android interface available");
            window.history.back();
        }
    };

    if (cards == null || cards.length === 0) {
        return (
            <LoadingScreenBlackLogo/>
        );
    }

    return (
        <div
            style={{
                backgroundColor: "rgba(255, 152, 0, 0.11)",
                width: "100%",
                display: 'flex',
                flexDirection: "column",
                overflowX: "hidden", // Prevent horizontal scrolling
                boxSizing: "border-box", // Include padding and border in width
            }} >
            {/* Header */}
            <header
                style={{
                    backgroundColor: "white",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    position: "sticky",
                    top: 0,
                    right: 0,
                    width: "100%",
                    zIndex: 10,
                }}
            >
                <div
                    style={{
                        verticalAlign: 'center',
                        display: "flex",
                        alignItems: "center", // Vertically aligns all child elements
                        justifyContent: "space-between",
                        padding: "0.75rem 1rem",
                        background: "linear-gradient(to right, #fff 0%, rgba(255, 152, 0, 0.11) 100%)",
                        color: "#681517"
                    }}
                >
                    <ArrowBackIosIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleBackButtonPress()}
                    />
                    {/* Main Menu */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center", // Vertically align MainMenu
                            color: "#681517"
                        }}
                    >
                        <MainMenu />
                    </div>

                    {/* Title */}
                    <div
                        style={{
                            marginLeft: "5px",
                            display: "flex",
                            flex: 1, // Ensures the title occupies available space
                            alignItems: "center", // Centers title vertically
                        }}
                    >
                        <h1
                            style={{
                                fontSize: "1.125rem",
                                color: "#681517",
                                margin: 0,
                                textAlign: "center",
                                lineHeight: 1, // Prevents additional line spacing
                            }}
                        >
                            Health Store
                        </h1>
                    </div>

                    {/* Right-Aligned Icons */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center", // Vertically aligns icons
                            gap: "1rem",
                        }}
                    >
                       

                        {/* Cart Icon with Count */}
                        <div
                            onClick={() => cartPageNavigation()}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                                cursor: "pointer",
                            }}
                            onMouseOver={(e) => (e.target.style.color = "#1f2937")}
                            onMouseOut={(e) => (e.target.style.color = "#6b7280")} >
                            {/* <img
                                src="https://appcdn.goqii.com/storeimg/4437_1733210653.webp"
                                alt="Cart Icon"
                                style={{ height: "1.5rem", width: "1.5rem" }}
                            /> */}
                            <ShoppingCartIcon size={24} color="#681517" />
                            {cartCount &&
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "-5px",
                                        right: "-5px",
                                        backgroundColor: "#681517",
                                        color: "white",
                                        fontSize: "0.75rem",
                                        fontWeight: "bold",
                                        width: "18px",
                                        height: "18px",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }} >
                                    {cartCount}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </header>




            {/* Main Content */}
            {cards.map((card, index) => (
                <div key={index}>
                    {card.cardType === "17" && card.itemType === "image" && (
                        <CategoriesScrollCard card={card} />
                    )}
                    {card.cardType === "16" && <OfferBannersCard card={card} />}
                    {card.cardType === "97" && <FlashSaleCard card={card} />}
                    {card.cardType === "17" &&
                        (card.itemType === "product" ||
                            card.itemType === "upcoming-flash-sale") && (
                            <Card17Product card={card} updateCartValue={handleCartCount} />
                        )}
                    {card.cardType === "22" && card.keyword != "social_follow_card" && <IconsGridCard card={card} />}
                    {card.cardType === "18" &&
                        <img src={card.cardData[0].data.imageUrl} width='100%' style={{ objectFit: 'cover' }} alt="Category" />}
                </div>
            ))}
            {isLoading && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "1rem 0",
                        backgroundColor: "#f9f9f9", // Soft background for a subtle look
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Adds a slight elevation effect
                    }}
                >
                    {/* Spinner */}
                    <div
                        style={{
                            width: "30px",
                            height: "30px",
                            border: "3px solid #e0e0e0",
                            borderTop: "3px solid #007bff", // Blue spinner for an active feel
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                            marginRight: "1rem", // Adds spacing between spinner and text
                        }}
                    ></div>

                    {/* Loading Text */}
                    <span
                        style={{
                            fontSize: "1rem",
                            fontWeight: "500",
                            color: "#555",
                        }}
                    >
                        Loading more items...
                    </span>

                    {/* Spinner Animation */}
                    <style>
                        {`
                    @keyframes spin {
                      0% {
                        transform: rotate(0deg);
                      }
                      100% {
                        transform: rotate(360deg);
                      }
                    }
                  `}
                    </style>
                </div>

            )}
        </div>

    );
};

export default StoreHomePage;
